export default {
  organizationname: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};
